export default __webpack_public_path__ + "static/media/15.3afc58cb.png";